@if (!list?.length && !loading) {
  <div class="noResults">
    {{ noResultStringByType | translate }}
  </div>
}
<div role="status">
  @if (listItemCount && list?.length) {
    <label-count [count]="listItemCount">{{ 'search.results_of' | translate }}: </label-count>
  }
  @if (!list?.length && !loading) {
    <span class="sr-only">
      {{ noResultStringByType | translate }}
    </span>
  }
</div>
@if (list?.length) {
  <listItems
    [type]="type"
    [list]="list"
    [compare]="compare"
  ></listItems>
}
@if (loading) {
  <loader></loader>
}
@if (loadingMore) {
  <loader class="loadMore"></loader>
}
@if (!loading && !loadingMore && canLoadMore) {
  <div class="loadMore">
    <button htm-button (click)="loadMore()" data-test-id="list-load-more-button">
      <span>{{ 'button.load_more' | translate }}</span>
      @if (listItemCount && list?.length && (listItemCount - list.length > 0)) {
        <span> ({{ listItemCount - list.length }})</span>
      }
    </button>
  </div>
  }<!--/loadMore-->


